import { render } from "./TopView.vue?vue&type=template&id=35bcc1d7&scoped=true"
import script from "./TopView.vue?vue&type=script&lang=js"
export * from "./TopView.vue?vue&type=script&lang=js"

import "./TopView.vue?vue&type=style&index=0&id=35bcc1d7&lang=scss&scoped=true"
import "./TopView.vue?vue&type=style&index=1&id=35bcc1d7&lang=css"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bcc1d7"]])

export default __exports__